module.exports = __webpack_public_path__ + "img/dependents.9d13eba4.jpeg";